export var Topic;
(function (Topic) {
    Topic["SYNC_PROGRESS"] = "sync.progress";
    Topic["APP_BACKGROUNDED"] = "app.backgrounded";
    Topic["APP_FOREGROUNDED"] = "app.foregrounded";
    Topic["APP_SCREEN_VIEWED"] = "app.screen.viewed";
    Topic["APP_AUTHENTICATION_COMPLETED"] = "app.authentication.completed";
    Topic["APP_AUTHENTICATION_FAILED"] = "app.authentication.failed";
    Topic["APP_AUTHENTICATION_STARTED"] = "app.authentication.started";
    Topic["APP_AUTHENTICATION_SIGNOUT"] = "app.authentication.signout";
    Topic["CONTENT_DOWNLOAD_COMPLETED"] = "content.download.completed";
    Topic["CONTENT_DOWNLOAD_DELETED"] = "content.download.deleted";
    Topic["CONTENT_DOWNLOAD_STARTED"] = "content.download.started";
    Topic["CONTENT_STATUS_COMPLETED"] = "content.status.completed";
    Topic["CONTENT_STATUS_UNCOMPLETED"] = "content.status.uncompleted";
    Topic["CONTENT_TAG_ADDED"] = "content.tag.added";
    Topic["CONTENT_TAG_REMOVED"] = "content.tag.removed";
    Topic["PLAYBACK_PAUSED"] = "playback.paused";
    Topic["PLAYBACK_SEEK"] = "playback.seek";
    Topic["PLAYBACK_STARTED"] = "playback.started";
    Topic["PLAYBACK_RESUMED"] = "playback.resumed";
    Topic["PLAYBACK_STATUS"] = "playback.status";
    Topic["PURCHASE_COMPLETED"] = "purchase.completed";
    Topic["PURCHASE_PRODUCT_SELECTED"] = "purchase.product.selected";
    Topic["PURCHASE_STARTED"] = "purchase.started";
    Topic["_IDENTIFY"] = "_identify";
})(Topic || (Topic = {}));
//# sourceMappingURL=Topic.js.map